import { Calendar, type CalendarProps } from "primereact/calendar";

type AdminCalendarProps = CalendarProps<"single">;
type AdminRangeCalendarProps = CalendarProps<"range">;

/**
 * Admin-standard Calendar defaults:
 * - UK date input format
 * - 24-hour time (when showTime is enabled)
 * - 15-minute increments
 * - typing enabled (readOnlyInput=false)
 */
function withAdminDefaults(props: {
  dateFormat?: string;
  hourFormat?: "12" | "24";
  stepMinute?: number;
  readOnlyInput?: boolean;
}) {
  return {
    dateFormat: props.dateFormat ?? "dd/mm/yy",
    hourFormat: props.hourFormat ?? ("24" as const),
    stepMinute: props.stepMinute ?? 15,
    readOnlyInput: props.readOnlyInput ?? false,
  };
}

export function AdminCalendar(props: AdminCalendarProps) {
  const defaults = withAdminDefaults(props);
  return <Calendar<"single"> {...props} {...defaults} />;
}

export function AdminRangeCalendar(props: AdminRangeCalendarProps) {
  const defaults = withAdminDefaults(props);
  return <Calendar<"range"> {...props} {...defaults} />;
}


